import * as actionLog from "../src/actionLog";

export function useActionLog() {
    return actionLog;
}
